import { useQuery } from '@tanstack/react-query'
import { getPublicSettings } from '@/api/publicSettingsApi'

export const publicSettingsKeys = {
  all: ['public-settings'] as const,
}

export function usePublicSettings() {
  return useQuery({
    queryKey: publicSettingsKeys.all,
    queryFn: getPublicSettings,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    refetchInterval: 10 * 1000,
  })
}
